import React from "react";
import DataTableScrollContainer from "components/ui/DataTableScrollContainer";
import {
  DataTableEmptyState,
  DataTableErrorState,
  DataTableLoadingState,
} from "components/ui/DataTableStates";
import { DATA_TABLE_TABLE_CLASS } from "lib/dataTableClasses";

type AdminDataTableProps = {
  isArabic: boolean;
  loading?: boolean;
  error?: string | null;
  onRetry?: () => void;
  empty?: boolean;
  emptyTitle?: string;
  emptyHint?: string;
  loadingMessage?: string;
  children: React.ReactNode;
  className?: string;
};

/**
 * Table card shell with consistent loading, empty, and error states.
 */
export default function AdminDataTable({
  isArabic,
  loading = false,
  error = null,
  onRetry,
  empty = false,
  emptyTitle,
  emptyHint,
  loadingMessage,
  children,
  className = "",
}: AdminDataTableProps) {
  return (
    <DataTableScrollContainer className={className}>
      {loading ? (
        <DataTableLoadingState
          message={
            loadingMessage ??
            (isArabic ? "جارٍ تحميل البيانات..." : "Loading data...")
          }
        />
      ) : error ? (
        <DataTableErrorState
          message={error}
          isArabic={isArabic}
          onRetry={onRetry}
        />
      ) : empty ? (
        <DataTableEmptyState
          title={
            emptyTitle ??
            (isArabic ? "لا توجد بيانات لعرضها" : "No data to display")
          }
          hint={emptyHint}
        />
      ) : (
        children
      )}
    </DataTableScrollContainer>
  );
}

export function AdminDataTableElement({
  isArabic,
  children,
  minWidth = "640px",
}: {
  isArabic: boolean;
  children: React.ReactNode;
  minWidth?: string;
}) {
  return (
    <table
      className={DATA_TABLE_TABLE_CLASS}
      style={{ minWidth }}
      dir={isArabic ? "rtl" : "ltr"}
    >
      {children}
    </table>
  );
}
